 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"1a48c3c1","2":"6728d85a","3":"1bfc9850","4":"fd53c0a9b76e6f7b3aa46f8cd2d131a99d3d0bd7","5":"0c428ae2","6":"d7eeaac4","7":"545f34e4","8":"5e2a4920","9":"78e521c3","11":"252f366e","12":"2b7b2d2a","13":"7779ef99","14":"a3ff1dbb","16":"b98bc7c3","17":"component---src-pages-404-js","18":"component---src-pages-cn-commitment-jsx","19":"component---src-pages-cn-company-profile-jsx","20":"component---src-pages-cn-philosophy-jsx","21":"component---src-pages-cn-product-brand-jsx","22":"component---src-pages-cn-toppage-jsx","23":"component---src-pages-company-activities-jsx","24":"component---src-pages-company-locations-jsx","25":"component---src-pages-company-profiles-department-introduction-jsx","26":"component---src-pages-company-profiles-jsx","27":"component---src-pages-company-vision-jsx","28":"component---src-pages-en-commitment-jsx","29":"component---src-pages-en-company-profile-jsx","30":"component---src-pages-en-philosophy-jsx","31":"component---src-pages-en-product-brand-jsx","32":"component---src-pages-en-toppage-jsx","33":"component---src-pages-index-js","34":"component---src-pages-inquiry-faq-page-jsx","35":"component---src-pages-inquiry-jsx","36":"component---src-pages-ourbusiness-bakery-shop-jsx","37":"component---src-pages-ourbusiness-flower-dep-jsx","38":"component---src-pages-ourbusiness-francois-jsx","39":"component---src-pages-ourbusiness-menshoku-jsx","40":"component---src-pages-ourbusiness-nbk-jsx","41":"component---src-pages-ourbusiness-overseas-venture-jsx","42":"component---src-pages-ourbusiness-sweets-jsx","43":"component---src-pages-pdf-leaflet-jsx","44":"component---src-pages-privacy-policy-jsx","45":"component---src-pages-recruitment-jsx","46":"component---src-pages-voice-of-employees-jsx","47":"component---src-templates-information-blog-template-jsx","48":"component---src-templates-voice-of-employees-template-jsx","49":"d64684d8","52":"styles"}[chunkId]||chunkId) + "-" + {"0":"89b194523a5cd34bd2bb","1":"f2f00fbddb05fa857a5a","2":"4b84b8dfd9787b6a97b4","3":"a471f034d203cfccf2e7","4":"83e3bbec6d610cfdd2f4","5":"3fd8f964d4df0844f905","6":"1224cdac630caeb2a588","7":"01b166e9e71ac7542275","8":"46110f515a0080b5d7a1","9":"ca0d9fa00fe8803561a0","11":"080b933cee5396c38466","12":"f31e3e46d96e6ac798e8","13":"9c94864b513e1149c3e4","14":"22407bb5ab804a289717","16":"24ddf8a796b26717620a","17":"987325564a307330808a","18":"92ed67816267e4784716","19":"08deaef4d04153cd8b20","20":"c09c6da904cf3da55c13","21":"7ea790478138e18a43d2","22":"4f55368fe15ad7435cbd","23":"43500b85d7cfefa42135","24":"68d72d47666f4517b33c","25":"f7b8e8d2f29098496386","26":"c7e697ac92efe05a5817","27":"5641553af580cb6fae30","28":"606e9cd5ee9c3431f90f","29":"214ed2db11062629a70c","30":"9c6c677822db8c42580f","31":"2d22a8ad40ef23b1395e","32":"68eeee1e8b3ac20b26ec","33":"aa0ea9e663ab5d046c52","34":"3ced3245a0233bb385ce","35":"92af2a36c677cbe0b249","36":"342fffbc9adc736283d7","37":"32befd1c6e58c5db079d","38":"d51fdbec11f727507329","39":"fd7375903f540316bd13","40":"2ebf69c8feced466ee84","41":"188dd09cf007acb33e4c","42":"b30693125c0a16f0c16e","43":"e0fe64a4d60c715826b0","44":"e7b92f12c2efe41f7e81","45":"ebf928d6d82a21e25d3d","46":"18a78d195e68b9770818","47":"6563f823dbb1c13513ae","48":"d27f5f113bb8e5585685","49":"34e224d97d34a34b254e","52":"592b48ad65215784c957"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"52":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"1a48c3c1","2":"6728d85a","3":"1bfc9850","4":"fd53c0a9b76e6f7b3aa46f8cd2d131a99d3d0bd7","5":"0c428ae2","6":"d7eeaac4","7":"545f34e4","8":"5e2a4920","9":"78e521c3","11":"252f366e","12":"2b7b2d2a","13":"7779ef99","14":"a3ff1dbb","16":"b98bc7c3","17":"component---src-pages-404-js","18":"component---src-pages-cn-commitment-jsx","19":"component---src-pages-cn-company-profile-jsx","20":"component---src-pages-cn-philosophy-jsx","21":"component---src-pages-cn-product-brand-jsx","22":"component---src-pages-cn-toppage-jsx","23":"component---src-pages-company-activities-jsx","24":"component---src-pages-company-locations-jsx","25":"component---src-pages-company-profiles-department-introduction-jsx","26":"component---src-pages-company-profiles-jsx","27":"component---src-pages-company-vision-jsx","28":"component---src-pages-en-commitment-jsx","29":"component---src-pages-en-company-profile-jsx","30":"component---src-pages-en-philosophy-jsx","31":"component---src-pages-en-product-brand-jsx","32":"component---src-pages-en-toppage-jsx","33":"component---src-pages-index-js","34":"component---src-pages-inquiry-faq-page-jsx","35":"component---src-pages-inquiry-jsx","36":"component---src-pages-ourbusiness-bakery-shop-jsx","37":"component---src-pages-ourbusiness-flower-dep-jsx","38":"component---src-pages-ourbusiness-francois-jsx","39":"component---src-pages-ourbusiness-menshoku-jsx","40":"component---src-pages-ourbusiness-nbk-jsx","41":"component---src-pages-ourbusiness-overseas-venture-jsx","42":"component---src-pages-ourbusiness-sweets-jsx","43":"component---src-pages-pdf-leaflet-jsx","44":"component---src-pages-privacy-policy-jsx","45":"component---src-pages-recruitment-jsx","46":"component---src-pages-voice-of-employees-jsx","47":"component---src-templates-information-blog-template-jsx","48":"component---src-templates-voice-of-employees-template-jsx","49":"d64684d8","52":"styles"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","52":"1e3169ebbb0d083d6bb3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
